export const SOCIETY_MENU_GUIDE = 'society.page.menu.guide';
export const SOCIETY_MENU_ABSTRACT = 'society.page.menu.abstract';
export const SOCIETY_MENU_REGISTER = 'society.page.menu.register';

export const SOCIETY_STEP_ABSTRACT_CONFIRM = 'society.step.abstractConfirm';
export const SOCIETY_STEP_REGISTER_CONFIRM = 'society.step.registerConfirm';

export const LEGACY_SOCIETY_MENU_MAP: Record<string, string> = {
	'학술행사 안내': SOCIETY_MENU_GUIDE,
	'초록 안내 및 등록': SOCIETY_MENU_ABSTRACT,
	'학술대회 등록': SOCIETY_MENU_REGISTER,
	'학술대회 안내': SOCIETY_MENU_GUIDE,
};

export const LEGACY_SOCIETY_STEP_MAP: Record<string, string> = {
	'초록 확인': SOCIETY_STEP_ABSTRACT_CONFIRM,
	'등록 확인': SOCIETY_STEP_REGISTER_CONFIRM,
};

export const normalizeSocietyMenu = (value?: string | null) => {
	if (!value) {
		return SOCIETY_MENU_GUIDE;
	}

	if (value === SOCIETY_MENU_GUIDE || value === SOCIETY_MENU_ABSTRACT || value === SOCIETY_MENU_REGISTER) {
		return value;
	}

	return LEGACY_SOCIETY_MENU_MAP[value] ?? SOCIETY_MENU_GUIDE;
};

export const normalizeSocietyStep = (value?: string | null) => {
	if (!value) {
		return '';
	}

	if (value === SOCIETY_STEP_ABSTRACT_CONFIRM || value === SOCIETY_STEP_REGISTER_CONFIRM) {
		return value;
	}

	return LEGACY_SOCIETY_STEP_MAP[value] ?? '';
};
